document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.view-options-button').forEach(function(button) {
    button.addEventListener('click', async function(event) {
      event.preventDefault();
      
      const productId = this.getAttribute('data-product-id');
      const productTitle = this.getAttribute('data-product-title');
      const productVendor = this.getAttribute('data-product-vendor');
      const productDescription = this.getAttribute('data-product-description');
      const productImage = this.getAttribute('data-product-image');
      const productUrl = this.getAttribute('data-product-url');
      
      console.log('Product ID:', productId);
      console.log('Product Title:', productTitle);
      console.log('Product Vendor:', productVendor);
      console.log('Product Description:', productDescription);
      console.log('Product Image:', productImage);
      console.log('Product URL:', productUrl);

      try {
        const productVariants = await fetchProductVariants(productId);
        const truncatedDescription = truncateDescription(productDescription, 150);
        
        Swal.fire({
          title: productTitle,
          html: `
            <div style="text-align: left;">
              <img src="${productImage}" alt="${productTitle}" style="width: 100%; max-width: 200px; float: left; margin-right: 20px;">
              <div>
                <h4>${productVendor}</h4>
                <p>${truncatedDescription}</p>
                <a href="${productUrl}">View Full Details</a>
              </div>
              <div style="clear: both;"></div>
              <div style="margin-top: 20px;">
                <label for="variant-select">Size</label>
                <select id="variant-select">${productVariants}</select>
              </div>
              <div style="margin-top: 20px;">
                <label for="quantity" style="display: block;">Quantity</label>
                <div style="display: flex; align-items: center; gap: 10px;">
                  <button id="decrease-quantity" style="padding: 5px 10px; margin-top: 0px; width: 10%;">-</button>
                  <input type="number" id="quantity" name="quantity" min="1" value="1" style="width: 50px; text-align: center;">
                  <button id="increase-quantity" style="padding: 5px 10px; margin-top: 0px; width: 10%;">+</button>
                </div>
              </div>
              <button id="add-to-cart" class="btn btn--primary" style="margin-top: 20px;">Add to Cart</button>
            </div>
          `,
          showConfirmButton: false
        });

        // Add event listeners for the increment and decrement buttons
        document.getElementById('decrease-quantity').addEventListener('click', function() {
          const quantityInput = document.getElementById('quantity');
          const currentQuantity = parseInt(quantityInput.value);
          if (currentQuantity > 1) {
            quantityInput.value = currentQuantity - 1;
          }
        });

        document.getElementById('increase-quantity').addEventListener('click', function() {
          const quantityInput = document.getElementById('quantity');
          quantityInput.value = parseInt(quantityInput.value) + 1;
        });

        document.getElementById('add-to-cart').addEventListener('click', function() {
          const variantId = document.getElementById('variant-select').value;
          const quantity = document.getElementById('quantity').value;
          addToCart(variantId, quantity).then(() => {
            Swal.close();
          });
        });
      } catch (error) {
        console.error('Error fetching product variants:', error);
        Swal.fire({
          title: 'Error',
          text: 'There was an error loading the product details. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    });
  });

  async function fetchProductVariants(productId) {
    const query = `
    {
      product(id: "gid://shopify/Product/${productId}") {
        variants(first: 100) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }`;
    
    const accessToken = 'f540e469e1c6196a65cc6f56644d66d2';
    const response = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: query
    });

    if (!response.ok) {
      throw new Error(`GraphQL query failed: ${response.statusText}`);
    }

    const responseBody = await response.json();
    if (responseBody.errors) {
      throw new Error(`GraphQL query errors: ${responseBody.errors.map(e => e.message).join(', ')}`);
    }

    const variantsHtml = responseBody.data.product.variants.edges.map(edge => {
      const variantId = edge.node.id.split('/').pop(); // Extract numeric ID
      return `<option value="${variantId}">${edge.node.title}</option>`;
    }).join('');
    
    console.log('Product Variants HTML:', variantsHtml);
    return variantsHtml;
  }

  function truncateDescription(description, maxLength) {
    if (description.length <= maxLength) {
      return description;
    }
    return description.substring(0, maxLength) + '...';
  }

  async function addToCart(variantId, quantity) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    console.log('Adding to cart:', { variantId, quantity });

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error adding to cart: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Add to cart response:', data);
    // Automatically opens the cart drawer
  }
});

document.addEventListener('click', function(e) {
  if (e.target.matches('.free-gift-button')) {
    const button = e.target;
    const title = button.getAttribute('data-gwp-title');
    const description = button.getAttribute('data-gwp-description');
    const image = button.getAttribute('data-gwp-image');
    const disclaimer = button.getAttribute('data-gwp-disclaimer');
    
    let popupContent = `
      <div style="text-align: left;">
        ${image ? `<img src="${image}" alt="${title}" style="width: 100%; max-width: 200px; margin-bottom: 20px;">` : ''}
        <div>
          <p>${description}</p>
          ${disclaimer ? `<p class="small">${disclaimer}</p>` : ''}
        </div>
      </div>
    `;

    Swal.fire({
      title: title,
      html: popupContent,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      customClass: {
        confirmButton: 'btn btn--primary'
      }
    });
  }
});